export default __webpack_public_path__ + "static/media/angelica.png.webp";